import { render, staticRenderFns } from "./UpdatePasswordForm.vue?vue&type=template&id=68be6f07"
import script from "./UpdatePasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePasswordForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports